/**
 * Created by bszggg on 2021. 02. 27..
 */
const Props = {
  API_URL:"api1_0_0/",
  _BASE_URL_AUTOGENERATE_PORT:3000,
  BASE_URL:"https://szamlakezeloapi.profitsoft.hu/"

};

export default Props;
